import React from 'react';
import styled from 'styled-components'
import CartItem from '../Cart/CartItem';

const CheckoutCartItemsContainer = styled.div`
  max-height: calc(100vh - 279px);
  overflow-y: auto;
  padding-top: 15px;
  margin-top: 15px;
  width: 100%;
  border-top: 1px solid ${(props) => props.theme.colors.NEU_200};

`;

const CartItemsList = ({ cartItems, storeHideVat, noDelete }) => {

  return (
    <CheckoutCartItemsContainer>
      {cartItems.map((item, i) => item && <CartItem key={i} info={item} hideVAT={storeHideVat} noDelete={noDelete} />)}
    </CheckoutCartItemsContainer>
  );
};

export default CartItemsList;
